export type AnimationTypes =
  | 'idle'
  | 'walk-right'
  | 'walk-left'
  | 'walk-up'
  | 'walk-down'
  | 'idle-down'
  | 'idle-up'
  | 'idle-left'
  | 'thumbsup'
  | 'wave'
  | 'meditate'
  | 'sing'
  | 'defeated'
  | 'hurt'
  | 'attack';

export type FrameConfiguration = Record<
  AnimationTypes,
  { start: number; end: number }
>;

export interface DefaultCharacterTextures {
  clothes: DefaultTexture;
  shoes: DefaultTexture;
  hair: DefaultTexture;
  pants: DefaultTexture;
  complexion: DefaultTexture;
}

export interface DefaultTexture {
  spritesheet: string;
  dollView: string;
}

// Daily Activities
export enum DailyType {
  MINIGAME = 'minigame',
  DUEL = 'duel',
}

export const DEFAULT_TEXTURES: DefaultCharacterTextures = {
  clothes: {
    spritesheet: 'clothes-default',
    dollView: 'ui-blue-loose-shirt-small',
  },
  shoes: {
    spritesheet: 'shoes-default',
    dollView: 'ui-brown-shoes-small',
  },

  hair: {
    spritesheet: 'hair-default',
    dollView: 'ui-orange-ponytail-small',
  },
  pants: {
    spritesheet: 'pants-default',
    dollView: 'ui-grey-long-pants-small',
  },
  complexion: {
    spritesheet: 'complexion-default',
    dollView: 'complexion-3',
  },
};

export const getComplexionColor = (complexion: string) => {
  switch (complexion) {
    case 'Very Light Complexion':
      return '#dbbd9a';
    case 'Light Complexion':
      return '#c89a89';
    case 'Medium Complexion':
      return '#edb97c';
    case 'Dark Complexion':
      return '#bf8257';
    case 'Very Dark Complexion':
      return '#803a21';
    default:
      return '#edb97c';
  }
};

export const canAffordColor = 0xace673;
export const cannotAffordColor = 0xe64539;
